import type { RouteRecordRaw } from 'vue-router';
import { EMPLOYEE_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const employeeCheckinRoutes: RouteRecordRaw = {
  path: '/employee-checkin',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES,
      path: '',
      component: () => import('./EmployeeCheckin.vue'),
    },
  ],
};

export const employeeRedirects: RouteRecordRaw[] = [
  { path: '/', redirect: { name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES }, meta: { requireAuth: true } },
  { path: '/employee', redirect: { name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES } },
  { path: '/employee/pick-employees', redirect: { name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES } },
  { path: '/employee/list-employee', redirect: { name: EMPLOYEE_ROUTE_NAME.LIST_EMPLOYEE } },
  { path: '/list-employee', redirect: { name: EMPLOYEE_ROUTE_NAME.LIST_EMPLOYEE } },
  { path: '/pick-employees', redirect: { name: EMPLOYEE_ROUTE_NAME.PICK_EMPLOYEES } },
];
